import { render, staticRenderFns } from "./padding.vue?vue&type=template&id=0831f6ac&"
import script from "./padding.vue?vue&type=script&lang=js&"
export * from "./padding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports